(function () {
    // Datenhub URL live/test
    window.datahubUrl = Shopify.shop === 'lengermann-trieschmann.myshopify.com' ? 'https://hub.l-t.de' : 'https://lt-hubstage.die-etagen.de';
}());
